import { createContext, useContext, useEffect, useReducer } from 'react';
import commentsReducer from '../reducer/commentsReducer';
import useAsyncDispatchComment from '../middleware/useAsyncDispatchComment';
import { useUser } from './UserProvider';
import { useSettings, useSettingsDispatch } from './SettingsProvider';

const CommentsContext = createContext(null);
const CommentsDispatchContext = createContext(null);

export function CommentsProvider({ config, children }) {
  const [commentsContext, dispatch] = useReducer(
    commentsReducer,
    {
      ...config,
      offset: 0,
      comments: {},
      count: 0,
    }
  );
  const asyncDispatch = useAsyncDispatchComment(commentsContext, dispatch);

  const settings = useSettings();
  const settingsDispatch = useSettingsDispatch();
  const userContext = useUser();

  useEffect(() => {
    asyncDispatch({type: 'init'});
  }, [userContext])

  useEffect(() => {
    if(settings.deferedComment !== null){
      asyncDispatch({type: 'add', ...settings.deferedComment});
      settingsDispatch({type: 'update', payload: {deferedComment: null}});
    }
  }, [commentsContext])


  return (
    <CommentsContext.Provider value={commentsContext}>
      <CommentsDispatchContext.Provider value={asyncDispatch}>
        {children}
      </CommentsDispatchContext.Provider>
    </CommentsContext.Provider>
  );
}

export function useComments() {
  return useContext(CommentsContext);
}

export function useCommentsDispatch() {
  return useContext(CommentsDispatchContext);
}
